/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useState } from 'react';
import { AnnouncementBarV2 } from 'views/rebranded-module/common/components';
import {
    NewWidgetTitle, 
    NewWidgetAlert,
    NewWidgetWarning
  } from 'views/rebranded-module/common/components/UI/NewMainWidget';
import { RENTAL_WIDGET, TOUR_WIDGET, TOUR_TYPES } from 'lib/utils/mainWidgetConstants';
import {
  NewTourWidgetWrapper,
  NewRentalWidgetWrapper,
} from 'views/rebranded-module/common/components/Logical/NewMainWidgetWrapper/';
import StyledBox from 'views/rebranded-module/common/components/UI/NewMainWidget/NewMainWidget.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const NewMainWidget = (props:any) => {
  const {
    shouldHideTitle,
    vertical,
    className,
    alertMassage,
    titleColor,
    announcementBar,
    widgetInfo,
    handleWidgetTypeSelect,
    handleRentalWidgetSearchClick,
    handleTourWidgetSearchClick,
    renderAllWidget = true,
    handleRenderAllWidget = () => {},
    renderAllProductOptionsProp = true,
    isDealWidget,
    showStartYourAdventureLabel,
  } = props;

  const cmsData = useContent('NewMainWidgetComponent');
  const [rentalWidgetWarnings, setRentalWidgetWarnings] = useState([]);
  const [renderAllProductOptions, setRenderAllProductOptions] = useState(
    renderAllProductOptionsProp,
  );
  const [selectedTourType, setSelectedTourType] = useState(null);

  const updateRenderAllProductOptions = (showAllproductOptions) => {
    if (renderAllProductOptionsProp) {
      setRenderAllProductOptions(showAllproductOptions);
    }
  };

  const updateRentalWidgetWarnings = (warnings) => {
    setRentalWidgetWarnings(warnings);
  };

  const handleTourTypeSelect = (tourType) => {
    setSelectedTourType(tourType);
  };

  // eslint-disable-next-line consistent-return
  const renderAnnouncment = () => {
    if (announcementBar) {
      return <AnnouncementBarV2 vertical={vertical} />;
    }
  };
  const renderWidget = () => {
    const rentalWidget = (
      <NewRentalWidgetWrapper
        {...props}
        vertical={vertical}
        isDealWidget={isDealWidget}
        renderAllWidget={renderAllWidget}
        handleRenderAllWidget={handleRenderAllWidget}
        handleRentalWidgetSearchClick={handleRentalWidgetSearchClick}
        updateRentalWidgetWarnings={updateRentalWidgetWarnings}
        updateRenderAllProductOptions={updateRenderAllProductOptions}
      />
    );
    const tourTypesList = [
      { id: null, name: cmsData.allMotorcycleTours },
      { id: TOUR_TYPES.GUIDED, name: cmsData.guidedMotorcycleTours },
      { id: TOUR_TYPES.SELF, name: cmsData.selfDriveMotorcycleTours },
    ];
    switch (widgetInfo.type) {
      case RENTAL_WIDGET:
        return rentalWidget;
      case TOUR_WIDGET:
        return (
          <NewTourWidgetWrapper
            {...props}
            vertical={vertical}
            tourTypesList={tourTypesList}
            renderAllWidget={renderAllWidget}
            handleRenderAllWidget={handleRenderAllWidget}
            handleTourWidgetSearchClick={handleTourWidgetSearchClick}
            handleTourTypeSelect={handleTourTypeSelect}
          />
        );
      default:
        return rentalWidget;
    }
  };
  return (
    <StyledBox
      className={`mainWidget ${className}`}
      >
      {rentalWidgetWarnings.length > 0 && (
        <NewWidgetWarning alertMessage={rentalWidgetWarnings} />
      )}
      {!shouldHideTitle && (
        <NewWidgetTitle
          widgetInfo={widgetInfo}
          vertical={vertical}
          titleColor={titleColor}
          handleWidgetTypeSelect={handleWidgetTypeSelect}
          renderAllProductOptions={renderAllProductOptions}
          selectedTourType={selectedTourType}
          showStartYourAdventureLabel={showStartYourAdventureLabel}
        />
      )}
      {alertMassage && <NewWidgetAlert alertMassage={alertMassage} />}
      {renderWidget()}
      {renderAllWidget && renderAnnouncment()}
      
    </StyledBox>
  );
};

export { NewMainWidget };